import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import getters from "./getters";
import websocket from "./modules/websocket";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    websocket,
  },
  getters,
});

export default store;
